import React from 'react';
import { ArrowSquareOut, Eye, FolderOpen } from '@phosphor-icons/react';
import GenericTables from '../../../shared/components/ui/GenericTables.jsx';
import ActionMenu from '../../../shared/components/ui/ActionMenu.jsx';
import { formatFileSize, formatDate } from '../../../shared/utils/fileFormat.js';
import FileExplorerEntryIcon from './FileExplorerEntryIcon.jsx';

const DELETED_TASK_TITLE = 'Tarea eliminada';

// El backend marca la tarea borrada solo con el texto de taskTitle; si llega
// a mandar el booleano taskDeleted, ese tiene prioridad sobre la comparación.
export const isResultTaskDeleted = (result) => (
  typeof result.taskDeleted === 'boolean'
    ? result.taskDeleted
    : result.taskTitle === DELETED_TASK_TITLE
);

const FileExplorerSearchResults = ({
  results,
  loading,
  error,
  search,
  pagination,
  onRetry,
  onPreview,
  onOpenFolder,
  onViewTask
}) => {
  if (error) {
    return (
      <div className="flex flex-col items-center justify-center gap-3 py-16 px-4 text-center text-content">
        <p>{error.message}</p>
        {error.retryable && (
          <button
            type="button"
            onClick={onRetry}
            className="px-4 py-2 rounded-md bg-amber hover:bg-amber-hover text-on-amber text-sm font-medium transition-colors"
          >
            Reintentar
          </button>
        )}
      </div>
    );
  }

  const columns = [
    {
      key: 'icon',
      label: '',
      mobileHidden: true,
      render: (result) => <FileExplorerEntryIcon entry={result} />
    },
    { key: 'name', label: 'Nombre', mobilePrimary: true },
    {
      key: 'taskTitle',
      label: 'Tarea',
      render: (result) => (
        <span className={isResultTaskDeleted(result) ? 'italic text-content-muted' : ''}>
          {result.taskTitle}
        </span>
      )
    },
    { key: 'size', label: 'Tamaño', render: (result) => formatFileSize(result.size) },
    { key: 'createdAt', label: 'Modificado', render: (result) => formatDate(result.createdAt) },
    {
      key: 'actions',
      label: '',
      isAction: true,
      render: (result) => {
        // Con la tarea borrada, tanto el detalle como su carpeta darían 404.
        const taskDeleted = isResultTaskDeleted(result);

        return (
          <ActionMenu
            options={[
              {
                label: 'Vista previa',
                icon: <Eye size={16} />,
                onClick: () => onPreview(result)
              },
              {
                label: 'Abrir carpeta',
                icon: <FolderOpen size={16} />,
                onClick: () => onOpenFolder(result),
                disabled: taskDeleted
              },
              {
                label: 'Ir a la tarea',
                icon: <ArrowSquareOut size={16} />,
                onClick: () => onViewTask(result.taskId),
                disabled: taskDeleted || !onViewTask
              }
            ]}
          />
        );
      }
    }
  ];

  return (
    <GenericTables
      columns={columns}
      data={results}
      loading={loading}
      loadingMessage="Buscando..."
      emptyMessage={`Sin resultados para "${search}"`}
      showFooter
      pagination={pagination}
      onRowClick={onPreview}
    />
  );
};

export default FileExplorerSearchResults;
